import { addMessages } from '@hana/i18n';

// Chuỗi giao diện của vùng HANA Kit (dữ liệu mẫu, mã bảng, tên người không dịch).
addMessages('vi', {
  'kit.adminTitle': 'Quản trị hệ thống',
  'kit.adminInfo': 'Cấu hình là dữ liệu có lịch sử · chủ nghiệp vụ sở hữu',
  'kit.find': 'Tìm tham số, bảng, người…',
  'kit.findLabel': 'Tìm cấu hình',
  'kit.queue': 'Hàng chờ thay đổi',
  'kit.rightPanel': 'Cột phải: chờ tôi duyệt',
  'kit.groups': 'Nhóm quản trị',
  'kit.params': 'Trung tâm tham số & quy tắc',
  'kit.paramsInfo': 'Mọi con số nghiệp vụ là dữ liệu: có chủ, ngày hiệu lực và lịch sử. Không sửa code để đổi luật.',
  'kit.owner': 'Chủ nghiệp vụ: {o}',
  'kit.thValue': 'Giá trị',
  'kit.thUnit': 'Đơn vị',
  'kit.thOwner': 'Chủ',
  'kit.thSince': 'Hiệu lực',
  'kit.thLast': 'Sửa cuối',
  'kit.itemOwner': '{l} · chủ {o}',
  'kit.history': 'Lịch sử toàn bảng',
  'kit.addParam': 'Tham số',
  'kit.tabs': 'Phân mục',
  'kit.noPermTitle': 'Quản trị chỉ mở cho ADMIN và chủ nghiệp vụ',
  'kit.noPermDesc': 'Ghế của anh không có cờ ADMIN.',
  'kit.askAccess': 'Xin quyền',
  'kit.askSent': 'Đã gửi yêu cầu cấp quyền ADMIN (bản mẫu, chưa ghi)',
  'kit.errTitle': 'Không tải được cấu hình',
  'kit.emptyTitle': 'Chưa có tham số',
  'kit.moving': 'Mục này chuyển sang HANA Kit sáng 02/Nov',
  'kit.movingDesc': 'Bản đang chạy vẫn mở ở {path}.',
  'kit.openCurrent': 'Mở bản đang chạy',
  'kit.backAdmin': 'Về Quản trị hệ thống',
  'kit.later': 'Bản mẫu, chưa ghi',
  'kit.rl.zMain': 'Dùng chính',
  'kit.rl.zYes': 'Thấy',
  'kit.rl.zPerm': 'Theo quyền',
  'kit.rl.zNo': 'Không thấy',
  'kit.rl.cVp': 'Văn phòng',
  'kit.rl.cHt': 'Hiện trường',
  'kit.rl.cXe': 'Trên xe',
  'kit.rl.dPc': 'Desktop',
  'kit.rl.dPad': 'iPad',
  'kit.rl.dPh': 'Điện thoại',
  'kit.rl.nOk': 'Ổn định',
  'kit.rl.nMid': 'Chập chờn',
  'kit.rl.nLow': 'Yếu / mất sóng',
  'kit.rl.fN': 'Ngày',
  'kit.rl.fT': 'Tuần',
  'kit.rl.fTh': 'Tháng',
  'kit.rl.thin': 'JD mỏng',
  'kit.rl.warn': 'Lưu ý JD',
  'kit.rl.inferNet': 'Suy luận · kết nối: {v}',
  'kit.rl.open': 'Mở hồ sơ vai trò {c} · {n}',
  'kit.rl.level': 'Bậc',
  'kit.rl.purposeJd': 'Mục đích · JD',
  'kit.rl.inferCtx': 'Suy luận · bối cảnh: {v}',
  'kit.rl.inferDev1': 'Suy luận · thiết bị chính: {v}',
  'kit.rl.inferDev2': 'Suy luận · thiết bị phụ: {v}',
  'kit.rl.inferZone': 'Suy luận · {z} · {v}',
  'kit.rl.fromJd': 'Từ JD',
  'kit.rl.jdBrief': 'JD · tóm gọn',
  'kit.rl.onSystem': 'Trên hệ thống',
  'kit.rl.infer': 'Suy luận',
  'kit.rl.interviewQ': 'Câu hỏi phỏng vấn',
  'kit.rl.confirmAssume': 'Để xác nhận giả định',
  'kit.rl.purpose': 'Mục đích',
  'kit.rl.duties': 'Nhiệm vụ chính',
  'kit.rl.authority': 'Thẩm quyền',
  'kit.rl.levelDiff': 'Khác biệt theo bậc',
  'kit.rl.loops': 'Việc lặp trên hệ thống',
  'kit.rl.data': 'Dữ liệu',
  'kit.rl.decide': 'Quyết định / duyệt',
  'kit.rl.pains': 'Điểm đau dự kiến',
  'kit.rl.screens': 'Màn dùng',
  'kit.rl.hubZones': 'Vùng HANA Hub',
  'kit.rl.impl': 'Hệ quả thiết kế',
  'kit.rl.dutyN': '{a} / {b} dòng JD',
  'kit.rl.tasks': 'việc',
  'kit.rl.limits': 'hạn chế',
  'kit.rl.noExtra': 'không thêm quyền',
  'kit.rl.extraTasks': 'Việc thêm',
  'kit.rl.notAllowed': 'Chưa được làm',
  'kit.rl.noLevelRows': 'Chưa có dòng khác biệt theo bậc',
  'kit.rl.oneLevel': 'Một bậc {l} · chưa có dòng khác biệt',
  'kit.rl.ctx': 'Bối cảnh',
  'kit.rl.mainDev': 'Thiết bị chính',
  'kit.rl.conn': 'Kết nối',
  'kit.rl.freq': 'Tần suất',
  'kit.rl.estPer': 'Ước lượng mỗi kỳ',
  'kit.rl.mustSee': 'Cần thấy',
  'kit.rl.mustHide': 'Không được thấy',
  'kit.rl.threshold': 'Ngưỡng / chuyển cấp',
  'kit.rl.assume': 'Giả định',
  'kit.rl.board': 'Board {b}',
  'kit.rl.title': 'Hồ sơ vai trò',
  'kit.rl.roleUnit': 'vai',
  'kit.rl.jdVer': 'JD phiên bản · trạng thái',
  'kit.rl.export': 'Xuất bộ câu hỏi phỏng vấn',
  'kit.rl.exported': 'Đã xuất {n} câu hỏi phỏng vấn',
  'kit.rl.filterDept': 'Lọc theo phòng',
  'kit.rl.all': 'Tất cả',
  'kit.rl.allDept': 'Tất cả phòng',
  'kit.rl.thinOnly': 'Chỉ vai có JD mỏng / cần lưu ý',
  'kit.rl.loadErr': 'Không tải được dữ liệu.',
  'kit.rl.retry': 'Thử lại',
  'kit.rl.emptyMsg': 'Chưa có hồ sơ vai trò.',
  'kit.rl.noperm': 'Không có quyền xem hồ sơ vai trò.',
  'kit.rl.roleCount': 'Số vai',
  'kit.rl.reports': 'báo cáo {r}',
  'kit.rl.copied': 'Đã sao chép 3 câu hỏi · {c}',
  'kit.rl.copyQ': 'Sao chép câu hỏi',
  'kit.rl.prev': 'Vai trước',
  'kit.rl.next': 'Vai sau',
});
addMessages('en', {
  'kit.adminTitle': 'System admin',
  'kit.adminInfo': 'Configuration is data with history · owned by the business owner',
  'kit.find': 'Find parameter, table, person…',
  'kit.findLabel': 'Find configuration',
  'kit.queue': 'Change queue',
  'kit.rightPanel': 'Right panel: waiting for my approval',
  'kit.groups': 'Admin groups',
  'kit.params': 'Parameters & rules',
  'kit.paramsInfo': 'Every business number is data: owner, effective date and history. Change rules without code.',
  'kit.owner': 'Business owner: {o}',
  'kit.thValue': 'Value',
  'kit.thUnit': 'Unit',
  'kit.thOwner': 'Owner',
  'kit.thSince': 'Effective',
  'kit.thLast': 'Last edit',
  'kit.itemOwner': '{l} · owner {o}',
  'kit.history': 'Table history',
  'kit.addParam': 'Parameter',
  'kit.tabs': 'Sections',
  'kit.noPermTitle': 'Admin is open to ADMIN and business owners only',
  'kit.noPermDesc': 'Your seat has no ADMIN flag.',
  'kit.askAccess': 'Request access',
  'kit.askSent': 'ADMIN access requested (sample, not saved)',
  'kit.errTitle': 'Could not load configuration',
  'kit.emptyTitle': 'No parameters yet',
  'kit.moving': 'This section moves to HANA Kit on 02/Nov',
  'kit.movingDesc': 'The running version is still at {path}.',
  'kit.openCurrent': 'Open running version',
  'kit.backAdmin': 'Back to System admin',
  'kit.later': 'Sample, not saved',
  'kit.rl.zMain': 'Main use',
  'kit.rl.zYes': 'Visible',
  'kit.rl.zPerm': 'By permission',
  'kit.rl.zNo': 'Hidden',
  'kit.rl.cVp': 'Office',
  'kit.rl.cHt': 'On site',
  'kit.rl.cXe': 'On vehicle',
  'kit.rl.dPc': 'Desktop',
  'kit.rl.dPad': 'iPad',
  'kit.rl.dPh': 'Phone',
  'kit.rl.nOk': 'Stable',
  'kit.rl.nMid': 'Unstable',
  'kit.rl.nLow': 'Weak / offline',
  'kit.rl.fN': 'Daily',
  'kit.rl.fT': 'Weekly',
  'kit.rl.fTh': 'Monthly',
  'kit.rl.thin': 'Thin JD',
  'kit.rl.warn': 'JD note',
  'kit.rl.inferNet': 'Inferred · connection: {v}',
  'kit.rl.open': 'Open role profile {c} · {n}',
  'kit.rl.level': 'Level',
  'kit.rl.purposeJd': 'Purpose · JD',
  'kit.rl.inferCtx': 'Inferred · context: {v}',
  'kit.rl.inferDev1': 'Inferred · main device: {v}',
  'kit.rl.inferDev2': 'Inferred · secondary device: {v}',
  'kit.rl.inferZone': 'Inferred · {z} · {v}',
  'kit.rl.fromJd': 'From JD',
  'kit.rl.jdBrief': 'JD · summary',
  'kit.rl.onSystem': 'In the system',
  'kit.rl.infer': 'Inferred',
  'kit.rl.interviewQ': 'Interview questions',
  'kit.rl.confirmAssume': 'To confirm assumptions',
  'kit.rl.purpose': 'Purpose',
  'kit.rl.duties': 'Main duties',
  'kit.rl.authority': 'Authority',
  'kit.rl.levelDiff': 'Differences by level',
  'kit.rl.loops': 'Recurring work in the system',
  'kit.rl.data': 'Data',
  'kit.rl.decide': 'Decisions / approvals',
  'kit.rl.pains': 'Expected pain points',
  'kit.rl.screens': 'Screens used',
  'kit.rl.hubZones': 'HANA Hub zones',
  'kit.rl.impl': 'Design implications',
  'kit.rl.dutyN': '{a} / {b} JD lines',
  'kit.rl.tasks': 'tasks',
  'kit.rl.limits': 'limits',
  'kit.rl.noExtra': 'no extra rights',
  'kit.rl.extraTasks': 'Extra tasks',
  'kit.rl.notAllowed': 'Not yet allowed',
  'kit.rl.noLevelRows': 'No level differences yet',
  'kit.rl.oneLevel': 'Single level {l} · no differences yet',
  'kit.rl.ctx': 'Context',
  'kit.rl.mainDev': 'Main device',
  'kit.rl.conn': 'Connection',
  'kit.rl.freq': 'Frequency',
  'kit.rl.estPer': 'Estimate per period',
  'kit.rl.mustSee': 'Must see',
  'kit.rl.mustHide': 'Must not see',
  'kit.rl.threshold': 'Threshold / escalation',
  'kit.rl.assume': 'Assumption',
  'kit.rl.board': 'Board {b}',
  'kit.rl.title': 'Role profiles',
  'kit.rl.roleUnit': 'roles',
  'kit.rl.jdVer': 'JD version · status',
  'kit.rl.export': 'Export interview questions',
  'kit.rl.exported': 'Exported {n} interview questions',
  'kit.rl.filterDept': 'Filter by department',
  'kit.rl.all': 'All',
  'kit.rl.allDept': 'All departments',
  'kit.rl.thinOnly': 'Only roles with a thin / noted JD',
  'kit.rl.loadErr': 'Could not load data.',
  'kit.rl.retry': 'Retry',
  'kit.rl.emptyMsg': 'No role profiles yet.',
  'kit.rl.noperm': 'No permission to view role profiles.',
  'kit.rl.roleCount': 'Roles',
  'kit.rl.reports': 'reports to {r}',
  'kit.rl.copied': 'Copied 3 questions · {c}',
  'kit.rl.copyQ': 'Copy questions',
  'kit.rl.prev': 'Previous role',
  'kit.rl.next': 'Next role',
});
